import { Dispatch, SetStateAction } from 'react';

import { CreateSpeaker, Speaker } from '@/types/speakers.types';
import GlobalContainer from '@ui/container/global-container';
import Text from '@ui/text/text/text';
import { updateTranslateKey } from '@/utils/update-translation-key';

type TEditTitleProps = {
  workingSpeaker: Speaker | CreateSpeaker;
  setWorkingSpeaker: Dispatch<SetStateAction<Speaker | CreateSpeaker>>;
  baseLanguage: string;
  language: string;
};

const EditTitle = ({ workingSpeaker, setWorkingSpeaker, baseLanguage, language }: TEditTitleProps) => {
  return (
    <label htmlFor="title" className="flex-1 flex-column gap-4 width-100-percent">
      <Text design="GlobalIcoText3" className="P2 margin-l-16">
        Title{' '}
        <Text tag="span" design="GlobalIcoText2">
          *
        </Text>
      </Text>
      <GlobalContainer<'input'>
        id="title"
        TagName="input"
        type="text"
        value={workingSpeaker.job_title?.base}
        onChange={(e) =>
          setWorkingSpeaker((prev) => ({
            ...prev,
            job_title: updateTranslateKey({
              translateString: workingSpeaker.job_title ?? { base: '', changed: '' },
              input: e.target.value,
              baseLanguage,
              language,
            }),
          }))
        }
        css="background-color: transparent; width: 100%; padding: 10px 16px; outline: none; border: 1px solid var(--global-ico-text-3); border-radius: 100px;"
        className="P2"
        mode="GlobalIcoText1"
        placeholder="Add title"
      />
    </label>
  );
};

export default EditTitle;
